<script setup lang="ts">
import { progresso, visivel } from '@/store/preloader'
</script>

<template>
  <div class="route-preloader-track" :class="{ visivel }">
    <div class="route-preloader-bar" :style="{ width: `${progresso}%` }" />
  </div>
</template>

<style scoped>
.route-preloader-track {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.route-preloader-track.visivel {
  opacity: 1;
}

.route-preloader-bar {
  height: 100%;
  background: linear-gradient(90deg, #3461ff, #5855ff);
  box-shadow: 0 0 8px rgba(52, 97, 255, 0.6);
  transition: width 0.3s ease-out;
}
</style>
